module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_pp1_7005.f668543b.png";